import React from "react";
import { Outlet, NavLink } from "react-router-dom";
import { Receipt, Shield } from "lucide-react";

/**
 * Billing IA shell — left-rail provider sub-navigation + nested content area.
 * SOUND-447 (Billing epic, Phase C).
 *
 * Mirrors SettingsLayout: a left rail lists each billing PROVIDER, the content
 * area renders the active provider's page via <Outlet />. Disputifier is the
 * first provider; future providers (NMI, own invoices, …) slot in as siblings
 * in the `providers` array + a matching route in _app.js.
 *
 * Internal-only — gated at the route level via RequireRole role="internal".
 */
const providers = [
  {
    label: "Disputifier",
    to: "/billing/disputifier",
    icon: <Shield className="h-4 w-4" />,
  },
  // Future: { label: "NMI", to: "/billing/nmi", icon: <CreditCard className="h-4 w-4" /> },
];

export default function BillingLayout() {
  return (
    <div className="flex flex-col lg:flex-row min-h-[calc(100vh-3.5rem)]">
      {/* Sidebar */}
      <aside className="lg:w-64 flex-shrink-0 border-b lg:border-b-0 lg:border-r border-border">
        <div className="sticky top-0 px-3 py-5">
          <div className="flex items-center gap-2 px-2 mb-4">
            <Receipt className="h-5 w-5 text-muted-foreground" />
            <h2 className="text-base font-semibold text-foreground">Billing</h2>
          </div>

          <div className="px-2 mb-3 text-[11px] leading-relaxed text-muted-foreground">
            Outstanding invoices across billing providers.
          </div>

          <nav className="space-y-0.5">
            {providers.map((p) => (
              <NavLink
                key={p.to}
                to={p.to}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-2 py-2 text-sm rounded-md transition-colors ${
                    isActive
                      ? "bg-brand/10 text-foreground font-medium"
                      : "text-muted-foreground hover:bg-muted hover:text-foreground"
                  }`
                }
              >
                {p.icon}
                {p.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </aside>

      {/* Content */}
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
